"use strict";
var fails = require("../internals/fails");
var globalThis = require("../internals/global-this");
var $RegExp = globalThis.RegExp;
module.exports = fails(function() {
  var re = $RegExp(".", "s");
  return !(re.dotAll && re.test("\n") && re.flags === "s");
});
